import * as actions from './actions';
import { responseStatus } from '../../utils/constants';

export type State = {
  loading: boolean;
  salary: Array<Record<string, any>>;
  error: Record<string, string>;
  salaryLoaded?: string;
};

export default (
  state: State = {
    salary: [],
    error: {},
    loading: false,
  },
  action: any,
): State => {
  switch (action.type) {
    case actions.FETCH_SALARY:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_SALARY_SUCCESS:
      return {
        ...state,
        salary: action.payload,
        loading: false,
        salaryLoaded: responseStatus.SUCCESS,
      };
    case actions.FETCH_SALARY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        salaryLoaded: responseStatus.ERROR,
      };
    default:
      return state;
  }
};
